module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAvklEQVQ4y2NgIAH8//+fMSu/aHJmXuF/IP0IxCdRc/FUoOb7xcXFImBDCoqjSdRcdByIT2XmF3WADCgoaBAgSXNZWRlvfnGxKZD9FWhIKMmaswvLtYEaX2YXloTRXjNQ8bSB1ZzV0MBDP80gkJlfuIZszdkFJZbZ+UU/s/ILJxcUVCiQpBkEgBqPZRQUJQFdcCezoOgJSZpzCkqcgBrfAQ25CMHFxaRkMKDfizaD0nVOfpEfAzkgt7JSlIECAADQn7fdYoHx0AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./resources/images/a-edit_1x.png
// module id = 2268
// module chunks = 0